export const vendorsData = {
  all: {
    venues: {
      "wedding-venues": [
        {
          itemId: 4,
          name: "Ramada by Wyndham Bengaluru Yelahanka",
          image: "venues-all-6.webp",
          location: "delhi NCR",
          rating: 4.3,
          reviews: 7,
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
        },
        {
          itemId: 5,
          name: "Crown Plaza Okhla",
          image: "venues-all-5.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.6,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 6,
          name: "Holiday Inn Jaipur",
          image: "Holiday Inn Jaipur.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 7,
          name: "CIDCO Convention Centre",
          image: "CIDCO.webp",
          location: "mumbai",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 8,
          name: "Samode Palace",
          image: "Samode Palace.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 9,
          name: "Jaibagh Palace",
          image: "Jaibagh Palace.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 10,
          name: "Four Points by Sheraton",
          image: "Four Points by Sheraton.webp",
          location: "delhi",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 11,
          name: "POLO LUXURIOUS DESTINATION",
          image: "POLO LUXURIOUS DESTINATION.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 12,
          name: "Hotel Grand Maple",
          image: "Hotel Grand Maple.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 13,
          name: "Lalita Grand",
          image: "Lalita Grand.webp",
          location: "delhi",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 14,
          name: "The Pergola",
          image: "The Pergola.webp",
          location: "mumbai",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 15,
          name: "Stardom Resort Jaipur",
          image: "Stardom Resort Jaipur.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 16,
          name: "Chevron",
          image: "Chevron.webp",
          location: "delhi",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 17,
          name: "Radisson Blu Plaza Delhi Airport",
          image: "Radisson Blu Plaza Delhi Airport.webp",
          location: "delhi",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.5,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
      "banquet-halls": [
        {
          itemId: 18,
          name: "Umaid Palace",
          image: "umaid palace.webp",
          location: "Jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 19,
          name: "Novotel Jaipur Convention Centre",
          image: "Novotel Jaipur Convention.webp",
          location: "Jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 20,
          name: "Bamboo saa Resort and Spa",
          image: "bamboo resort.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 21,
          name: "Hotel Grand Maple",
          image: "Hotel Grand Maple.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 22,
          name: "CIDCO Convention Centre",
          image: "CIDCO.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 23,
          name: "Four Points by Sheraton",
          image: "Four Points by Sheraton.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 24,
          name: "Crown Plaza Mayur Vihar",
          image: "Crown Plaza Mayur vihar.webp",
          location: "Greater Noida, Delhi",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 25,
          name: "Radisson Blu Plaza Delhi Airport",
          image: "Radisson Blu Plaza Delhi Airport.webp",
          location: "Aerocity, Delhi",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 26,
          name: "Hotel Raj Bagh Palace",
          image: "Hotel Raj Bagh Palace.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
      farmhouses: [
        {
          itemId: 27,
          name: "Umaid Palace",
          image: "umaid palace.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 28,
          name: "Novotel Jaipur Convention Centre",
          image: "Novotel Jaipur Convention.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 29,
          name: "Bamboo Saa & Resort Spa",
          image: "bamboo resort.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 30,
          name: "CIDCO Convention Centre",
          image: "CIDCO.webp",
          location: "Navi Mumbai",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 31,
          name: "The Pergola",
          image: "The Pergola.webp",
          location: "Navi Mumbai",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 32,
          name: "Hotel Grand Maple",
          image: "Hotel Grand Maple.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
      "wedding-resorts": [
        {
          itemId: 33,
          name: "Rainforest Resort, Igatpuri",
          image: "Rainforest Resort Igatpuri.webp",
          location: "Mumbai",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 34,
          name: "Hotel Grand Maple",
          image: "Hotel Grand Maple.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 35,
          name: "Bamboo Saa Resort & Spa",
          image: "bamboo resort.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 36,
          name: "Chomu Palace Hotel",
          image: "chomu palace.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 37,
          name: "Aizaa Resorts & Hotels Jaipur",
          image: "aiza.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 38,
          name: "Amargarh Resort",
          image: "Amargarh Resort.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
      "party-halls": [
        {
          itemId: 39,
          name: "Jaibagh Palace",
          image: "jaibagh Palace.webp",
          location: "Jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 40,
          name: "Blue Sea Banquets",
          image: "Blue Sea Mumbai.webp",
          location: "Mumbai",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 41,
          name: "Radisson Blu Hotel Greater Noida",
          image: "Radisson Blu Hotel Greater Noida.webp",
          location: "Greater Noida",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 42,
          name: "Yaan Wellness Retreat",
          image: "Yaan Wellness Retreat.webp",
          location: "Udaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 43,
          name: "Radisson Blu Mumbai International Airport",
          image: "Radisson Blu Mumbai.webp",
          location: "Mumbai",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 44,
          name: "Tivoli Grand Resort Hotel",
          image: "Tivoli Grand Resort Hotel Delhi.webp",
          location: "delhi",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
      "destination-wedding": [
        {
          itemId: 45,
          name: "Jaibagh Palace",
          image: "jaibagh Palace.webp",
          location: "Jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 46,
          name: "Yaan Wellness & Retreat",
          image: "Yaan Wellness Retreat.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 47,
          name: "Grassfield Valley Resort",
          image: "Grassfield Valley Resort.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
    },
    photographers: {
      "wedding-photographers": [
        {
          itemId: 48,
          name: "Creation Frame Makers",
          image: "Creation Frame Makers.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 5.0,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 49,
          name: "Pixel Stream",
          image: "Pixel Stream.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 5.0,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 501,
          name: "Wedmeclick",
          image: "Wedmeclick.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.6,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 51,
          name: "The Wedding Donut",
          image: "The Wedding Donut.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.7,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 151,
          name: "7Clicks Photography",
          image: "7Clicks Photography.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.8,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 152,
          name: "Fearless Pheras",
          image: "Fearless Pheras.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 153,
          name: "Feeling Gajab",
          image: "Feeling Gajab.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 5.0,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
    },
    "planning-decor": {
      "wedding-planners": [
        {
          itemId: 200,
          name: "7 Grace Eventz",
          image: "7 Grace Eventz.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 201,
          name: "Bling It On",
          image: "bling It On.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 202,
          name: "Blissful Weddings",
          image: "Blissful Weddings.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 203,
          name: "Event Gurus",
          image: "Event Gurus.webp",
          location: "mumbai",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 204,
          name: "Eventmakers",
          image: "Eventmakers.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 205,
          name: "Purple Planet Events",
          image: "Purple Planet Events.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 206,
          name: "The Celebrators",
          image: "The Celebrators.webp",
          location: "mumbai",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 207,
          name: "The Shadi Vibes",
          image: "The Shadi Vibes.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 208,
          name: "Wedding Project India",
          image: "Wedding Project India.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
      "wedding-decorators": [
        {
          itemId: 209,
          name: "Zzeeh Wedding Planners",
          image: "Zzeeh Wedding Planners.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 210,
          name: "Yellow Umbrella Entertainments",
          image: "Yellow Umbrella Entertainments.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 211,
          name: "The Design Atelier",
          image: "The Design Atelier.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 212,
          name: "The Camellia Events",
          image: "The Camellia Events.webp",
          location: "mumbai",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 213,
          name: "Blue Sea Events & Entertainments",
          image: "Blue Sea and Entertainments.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 214,
          name: "Melting Flowers",
          image: "Melting Flowers.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 215,
          name: "Kashi Events",
          image: "Kashi Events.webp",
          location: "pune",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 216,
          name: "The Glitttering Arc",
          image: "The Glitttering Arc.webp",
          location: "mumbai",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 217,
          name: "The Partywala",
          image: "The Partywala.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 218,
          name: "Tiger Lily",
          image: "Tiger Lily.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
    },
  },
  delhi: {
    venues: {
      "wedding-venues": [
        {
          itemId: 54,
          name: "Ramada by Wyndham Bengaluru Yelahanka,Delhi",
          image: "venues-all.webp",
          location: "delhi NCR",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 55,
          name: "Crown Plaza Okhla Udaipur",
          image: "venues-all-2.webp",
          location: "udaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
        {
          itemId: 56,
          name: "Radisson Jaipur City Center",
          image: "venues-all-3.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
        },
      ],
    },
  },
  jaipur: {
    venues: {
      "wedding-venues": [
        {
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
          itemId: 57,
          name: "Ramada by Wyndham Bengaluru Yelahanka",
          image: "venues-all.webp",
          location: "Jaipur",
          variety: {
            firstPrice: 1000,
            secondPrice: 2000,
          },
        },
        {
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
          itemId: 58,
          name: "Crown Plaza Okhla",
          image: "venues-all-2.webp",
          location: "Jaipur",
          variety: {
            firstPrice: 1200,
            secondPrice: 2400,
          },
        },
        {
          rating: 4.9,
          reviews: {
            "no of reviews": 7,
          },
          itemId: 59,
          name: "Radisson Jaipur City Center",
          image: "venues-all-3.webp",
          location: "jaipur",
          variety: {
            firstPrice: 1500,
            secondPrice: 3000,
          },
        },
      ],
    },
  },
  udaipur: {
    venues: [
      {
        itemId: 60,
        name: "Ramada by Wyndham Bengaluru Yelahanka",
        image: "venues-all.webp",
        location: "delhi NCR",
        variety: {
          firstPrice: 1000,
          secondPrice: 2000,
        },
      },
      {
        rating: 4.9,
        reviews: {
          "no of reviews": 7,
        },
        itemId: 61,
        name: "Crown Plaza Okhla",
        image: "venues-all-2.webp",
        location: "udaipur",
        variety: {
          firstPrice: 1200,
          secondPrice: 2400,
        },
      },
      {
        rating: 4.9,
        reviews: {
          "no of reviews": 7,
        },
        itemId: 62,
        name: "Radisson Jaipur City Center",
        image: "venues-all-3.webp",
        location: "jaipur",
        variety: {
          firstPrice: 1500,
          secondPrice: 3000,
        },
      },
    ],
    rating: 4.9,
    reviews: {
      "no of reviews": 7,
    },
  },
  mumbai: {
    venues: [
      {
        itemId: 63,
        name: "Ramada by Wyndham Bengaluru Yelahanka",
        image: "venues-all.webp",
        location: "delhi NCR",
        variety: {
          firstPrice: 1000,
          secondPrice: 2000,
        },
      },
      {
        rating: 4.9,
        reviews: {
          "no of reviews": 7,
        },
        itemId: 64,
        name: "Crown Plaza Okhla",
        image: "venues-all-2.webp",
        location: "udaipur",
        variety: {
          firstPrice: 1200,
          secondPrice: 2400,
        },
      },
      {
        rating: 4.9,
        reviews: {
          "no of reviews": 7,
        },
        itemId: 65,
        name: "Radisson Jaipur City Center",
        image: "venues-all-3.webp",
        location: "jaipur",
        variety: {
          firstPrice: 1500,
          secondPrice: 3000,
        },
      },
    ],
    rating: 4.9,
    reviews: {
      "no of reviews": 7,
    },
  },
};
